module.exports = __webpack_public_path__ + "static/img/r-4-1-icon.3b8d2ae.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer3/en/role-4/r-4-1-icon.png
// module id = xgpo
// module chunks = 0